import _ from 'lodash';
import { store } from 'store/createStore';
import { ROLES } from '../consts';

export const currentGroup = prop => {
  try {
    const group = store.getState().auth.currentGroup;

    return prop ? group[prop] : group;
  } catch (err) {}
};

export const auth = () => {
  try {
    return store.getState().auth;
  } catch (err) {}
};

export function checkSuperPermission(el, role) {
  const { roles, history } = el.props;

  if (!roles.includes(role) && !roles.includes(ROLES.SUPERADMIN)) {
    history.push('/dashboard');
  }
}

export function checkPermission(el, role) {
  const { roles, history } = el.props;

  if (
    !roles.includes(role) &&
    !roles.includes(ROLES.ADMIN) &&
    !roles.includes(ROLES.SUPERADMIN)
  ) {
    history.push('/dashboard');
  }
}

export function hasPermission(role) {
  const state = store.getState();
  const roles = _.get(state, 'auth.currentGroup.myRoles', 'default');

  return (
    roles.includes(role) ||
    roles.includes(ROLES.ADMIN) ||
    roles.includes(ROLES.SUPERADMIN)
  );
}

/**
 * Check if at least one of the 'testRoles' is present in the 'currentRoles' array
 *
 * @param {*} testRoles a string or an array of string containing roles to test
 * @param {*} currentRoles the base roles to test against.
 * If not specified, the current user roles will be used
 *
 * @returns true if one of the testRoles was found and false otherwise
 */
export const hasAnyRole = (testRoles, currentRoles) => {
  if (!currentRoles) {
    const state = store.getState();
    currentRoles = _.get(state, 'auth.currentGroup.myRoles', []);
  }

  if (typeof testRoles === 'string') {
    return currentRoles.some(it => _.isEqual(it.toUpperCase(), testRoles.toUpperCase()));
  }

  if (Array.isArray(testRoles)) {
    return currentRoles.some(a =>
      testRoles.some(b => _.isEqual(a.toUpperCase(), b.toUpperCase()))
    );
  }

  throw new Error('testRoles must be a string or an array of strings');
};
